<div class="loading" *ngIf="loadingService.isLoading()">
  <div class="lds-dual-ring"></div>
</div>
<div class="app-content">
  <app-toasts aria-live="polite" aria-atomic="true" *ngIf="false"></app-toasts>
  <router-outlet></router-outlet>
</div>
<!-- <div class="content" role="main">
  <div class="fullScreen " id="identity-wallet"></div>
</div> -->